import { itemsCol } from '../../shared/array-types.js';
export const FORTUNATE_ID = 'AE92D0EF-4E53-4A1D-DD97-B0B2F3732BB8';
/** Both compiled status definitions and interned status_item_id references are valid wire forms. */
export function isFortunateStatus(status: Record<string, unknown>): boolean {
  const id = itemsCol(status, 'item_id') ?? (Array.isArray(status.status_item_id) ? status.status_item_id[0] : status.status_item_id);
  return String(id ?? '').toUpperCase() === FORTUNATE_ID;
}
/** A committed resource frame may arrive before the status tail. Never resolve a dependent swing in that gap. */
export class FortunatePending {
  private operations = new Map<string, string>();
  begin(actor: string, operation: string): void { this.operations.set(actor, operation); }
  correct(actor: string, operation: string): void {
    if (this.operations.get(actor) === operation) this.operations.delete(actor);
  }
  waiting(actor: string, statusInstalled: boolean): boolean {
    if (statusInstalled) this.operations.delete(actor);
    return this.operations.has(actor);
  }
}
/** Pinned no-draw universal action. A changed catalog contract must be reviewed before this lane uses it. */
export const FORTUNATE_LAYERS: Record<string, string> = {
  ability_activation_charges: '1', change_caster_luck: '-1', duration_int: '10', duration_type: 'minutes',
  if_caster_has_status_effect_not_active: FORTUNATE_ID, range: 'D82855E1-4BB9-93EA-6374-B9904318BC1D',
  roll_type_adv: 'ABF66E1E-DA79-4329-31FA-70D981032C06', triggers_on_next_roll_type: 'ABF66E1E-DA79-4329-31FA-70D981032C06',
  triggers_when_caster_gains_luck: '1', triggers_when_caster_turn_begins: '1',
};
export function fortunateDefinitionSupported(layers: Record<string, unknown>): boolean {
  return Object.keys(layers).length === Object.keys(FORTUNATE_LAYERS).length
    && Object.entries(FORTUNATE_LAYERS).every(([key, expected]) => {
      const v = layers[key]; return String(Array.isArray(v) && v.length === 1 ? v[0] : v) === expected
        && (!Array.isArray(v) || v.length === 1);
    });
}
